
<script>
/* jshint esversion: 6 */
import {watch, computed, inject } from 'vue'; 
import './../func.common.js'; 
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";


export default {
    name: 'InputField',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
        'disabled': Boolean,
        'fullSchema': Object,
        'hinted': String,
        'id': String,
        'model': Object,
        'schema': Object,
        'schemaId': Number,
    },
    setup(props) {
        const validateChild = inject('validateChild');
        const buttonFunctionParent = inject('buttonFunctionParent');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(helperName, () => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator
            };
            if (validateChild) {
                validateChild(toParent);
            }
        });


        function buttonClick(getfunction) {
            var toParent = {
                'id': props.schemaId,
                'functionVal': getfunction.functionVal,
                'argumentsVal': getfunction.argumentsVal
            };
            if (buttonFunctionParent) {
                buttonFunctionParent(toParent);
            }
        }

        function getSchemaButtonsInput() {
            return `col-${props.schema.buttons.buttonWidth[0]}`;
        }

        function getSchemaButtonsButton() {
            return `col-${props.schema.buttons.buttonWidth[1]}`;
        }

        function showPassword(type, schemaIdConst) {
            props.fullSchema.fields[schemaIdConst].inputType = type;
            props.fullSchema.fields[schemaIdConst].buttons.pType = type;
        }

        return {
            buttonClick,
            getSchemaButtonsInput,
            getSchemaButtonsButton,
            showPassword
        }
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .fieldInput(:class="[schema.size ? `${schema.size}`: 'col-12', disabled === true ? 'fieldDisabled': '']")
        .form-group.row.gx-3-align-items-left
            .col-12 
                label(
                    :for="id" 
                    v-if="schema.label && schema.label.length > 0"
                ) 
                    |{{ schema.label }}
                    span.redAst(v-if="schema.required === true") *
        .form-group.row.gx-3-align-items-left(
            :style="disabled === true ? 'cursor: not-allowed; opacity: 0.5' : ''"
        )
            .inputFieldMain(:class="schema.buttons ? getSchemaButtonsInput() : 'col-12'")
                template(v-if="disabled === true")
                    input.form-control(
                        :id="id" 
                        :type="schema.inputType" 
                        :name="schema.model" 
                        :value="model[schema.model]" 
                        v-model="model[schema.model]" 
                        disabled="disabled"
                        :class="schema.errorShow === true ? 'inputred' : ''"
                        :style="disabled === true ? 'pointer-events:none' : ''"
                    )
                template(v-if="disabled === false")
                    input.form-control(
                        :id="id" 
                        :type="schema.inputType" 
                        :name="schema.model" 
                        :value="model[schema.model]" 
                        v-model="model[schema.model]" 
                        :class="schema.errorShow === true ? 'inputred' : ''"
                        :style="disabled === true ? 'pointer-events:none' : ''"
                    )
            .eyeIcon(v-if="schema.buttons && schema.buttons.type === 'showPassword'" :class="schema.buttons ? getSchemaButtonsButton() : ''")
                font-awesome-icon(v-if="schema.buttons.pType === 'password'" icon="fa-solid fa-eye" @click="showPassword('text', schemaId)")
                font-awesome-icon(v-if="schema.buttons.pType === 'text'" icon="fa-solid fa-eye-slash" @click="showPassword('password', schemaId)")
            div(v-if="schema.buttons && schema.buttons.type === 'text'"  :class="[schema.buttons.allwaysEnabled === true ? 'buttonEnabled' : '', schema.buttons ? getSchemaButtonsButton() : '']")
                template(v-if="schema.buttons.visible && schema.buttons.visible === true")
                    template(v-if="schema.buttons.onclick")
                        button(@click="buttonClick(schema.buttons.onclick)" :class="schema.buttons.class")
                            | {{ schema.buttons.text }} 
                    template(v-if="!schema.buttons.onclick")
                        button(:class ="schema.buttons.class")
                            | {{ schema.buttons.text }}
            br
            .vueFormSmall.labelred(v-if="schema.errorShow === true")
                font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                |  {{ schema.errorText[0] }}
        .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
</template>